import { create } from 'zustand';

const useApartmentStore = create((set) => ({
  apartment: {},

  setApartment: (newApartment) => set({ apartment: newApartment }),

  clearApartment: () => set({ apartment: {} }),
}));

export default useApartmentStore;
